<div class="countdown-wrapper" [class.isPollQuestion]="isPollQuestion">
  <div class="left-block">
    @if (state?.liveEvent?.logo_url) {
    <div class="logo-container">
      <img class="logo" [src]="state?.liveEvent?.logo_url" />
    </div>
    } @if (state?.cmsLiveEvent?.liveEvent?.logo_url) {
    <div class="logo-container">
      <img class="logo" [src]="state?.cmsLiveEvent?.liveEvent?.logo_url" />
    </div>
    } @if ( !state?.cmsLiveEvent?.liveEvent?.logo_url &&
    !state?.liveEvent?.logo_url ) {
    <div class="logo-container">
      <img
        class="logo"
        [src]="auth.isLoggedIn() ? 'assets/logo.png' : 'assets/pre-login.png'"
      />
    </div>
    } @if (countdownHint) {
    <div class="countdown-hint">
      <span class="main-title">{{ countdownHint.title }}</span>
      <span class="details">{{ countdownHint.details }}</span>
    </div>
    }

    <ng-content></ng-content>
  </div>

  <div class="question-answer-container">
    <div class="question-answer-container__img">
      <img src="assets/icons/question_answer.svg" alt="" srcset="" />
    </div>
  </div>

  <div class="right-block">
    <img
      class="question-answer-img"
      src="assets/icons/question_answer_large.svg"
      alt=""
      srcset=""
    />
    <div class="right-block__text">
      <div class="main-title">
        {{ 'questionMockPhone.opinionPoll' | translate }}
      </div>
      <div class="sub-title">
        {{ 'questionMockPhone.wantYourOpinion' | translate }}
      </div>
    </div>
  </div>
</div>
